import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NfcIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nfc"}/>
}
